import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'mfa-step',
  templateUrl: './mfa-step.component.html',
  encapsulation: ViewEncapsulation.None
})
export class MfaStepComponent {
  @Input()
  public isLoading: boolean;

  @Input()
  public verificationCodeForm: FormArray;

  @Output()
  public insertVerificationCode: EventEmitter<string>;

  @Output()
  public toRecoveryCodeStep: EventEmitter<void>;

  constructor() {
    this.insertVerificationCode = new EventEmitter<string>();
    this.toRecoveryCodeStep = new EventEmitter<void>();
  }
}
